/* eslint-disable @next/next/no-img-element */

import Link from 'next/link';
import { classNames } from 'primereact/utils';
import React, { forwardRef, useContext, useImperativeHandle, useRef, useState, useEffect } from 'react';
import { AppTopbarRef } from '../types/types';
import { LayoutContext } from './context/layoutcontext';

import AuthController from '../controller/AuthController';
import AuthStorage from '../storage/AuthStorage';

const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
    const { layoutConfig, layoutState, onMenuToggle, showProfileSidebar } = useContext(LayoutContext);
    const menubuttonRef = useRef(null);
    const topbarmenuRef = useRef(null);
    const topbarmenubuttonRef = useRef(null);

    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current,
        topbarmenu: topbarmenuRef.current,
        topbarmenubutton: topbarmenubuttonRef.current
    }));


    const basePath = (process.env.NEXT_PUBLIC_BASE_PATH || "");

    //Proveniente de sakai
    const urlFullLogoMenuDefault = "assets/layout/images/logo-dark.png";

    const [urlFullLogoMenu, setUrlFullLogoMenu] = useState(undefined);
    const [title, setTitle] = useState(undefined);

    useEffect(() => {

        const authStorage = new AuthStorage(window.location.pathname.toLowerCase());
        let dataConfigSubdomain = authStorage.getConfigSubdomain();


        let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoMenu, title } = dataConfigSubdomain;

        let newUrlFullLogoMenu = urlLogoMenu ? process.env.NEXT_PUBLIC_URL_API + urlLogoMenu : urlFullLogoMenuDefault || "";
        setTitle(title);

        setUrlFullLogoMenu(newUrlFullLogoMenu);


    }, []);
    // Fin de sakai

    if (typeof window !== undefined) {



        return (
            <div className="layout-topbar">
                <Link href="/" className="layout-topbar-logo">
                    <img src={basePath + `/layout/images/logo-${layoutConfig.colorScheme !== 'light' ? 'white' : 'dark'}.svg`} width="47.22px" height={'35px'} alt="logo" />
                    <span>SAKAI</span>
                </Link>

                <button ref={menubuttonRef} type="button" className="p-link layout-menu-button layout-topbar-button" onClick={onMenuToggle}>
                    <i className="pi pi-bars" />
                </button>

                <button ref={topbarmenubuttonRef} type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={showProfileSidebar}>
                    <i className="pi pi-ellipsis-v" />
                </button>

                <div ref={topbarmenuRef} className={classNames('layout-topbar-menu', { 'layout-topbar-menu-mobile-active': layoutState.profileSidebarVisible })}>
                    <button type="button" className="p-link layout-topbar-button">
                        <i className="pi pi-calendar"></i>
                        <span>Calendar</span>
                    </button>
                    <button type="button" className="p-link layout-topbar-button">
                        <i className="pi pi-user"></i>
                        <span>Profile</span>
                    </button>
                    <Link href="/documentation">
                        <button type="button" className="p-link layout-topbar-button">
                            <i className="pi pi-cog"></i>
                            <span>Settings</span>
                        </button>
                    </Link>
                </div>
            </div>
        );

    }
    else {
        return (<></>);
    }

});

AppTopbar.displayName = 'AppTopbar';

export default AppTopbar;
